import type { ResumeData } from "@reactive-resume/schema";
import { defaultLayoutForTemplate } from "@reactive-resume/schema";

export const reuseResumeData = (current: ResumeData, source: ResumeData): ResumeData => {
  const result = structuredClone(source);
  result.metadata = structuredClone(current.metadata);
  result.metadata.notes = source.metadata.notes;
  result.basics.picture = {
    ...structuredClone(current.basics.picture),
    url: source.basics.picture.url,
  };

  for (const key of Object.keys(result.sections) as (keyof ResumeData["sections"])[]) {
    if (key === "custom") continue;
    result.sections[key].columns = current.sections[key].columns;
    result.sections[key].separateLinks = current.sections[key].separateLinks;
  }

  const sectionKeys = Object.keys(result.sections)
    .filter((key) => key !== "custom")
    .concat(Object.keys(result.sections.custom).map((key) => `custom.${key}`));
  const validKeys = new Set(["basics", ...sectionKeys]);
  const layout = result.metadata.layout.length
    ? result.metadata.layout
    : defaultLayoutForTemplate(result.metadata.template);
  result.metadata.layout = layout.map((page) =>
    page.map((column) => column.filter((key) => validKeys.has(key))),
  );
  result.metadata.layout[0][0] ??= [];
  const placed = new Set(result.metadata.layout.flat(2));
  result.metadata.layout[0][0].push(...sectionKeys.filter((key) => !placed.has(key)));
  return result;
};
